import { Dispatch, SetStateAction, useEffect, useState } from 'react'

export default function useDebounce<T>(
  initialValue: T | (() => T),
  delay: number,
): [T, Dispatch<SetStateAction<T>>, T] {
  const [immediateNewValue, setImmediateNewValue] = useState(initialValue)
  const [debouncedValue, setDebouncedValue] = useState(immediateNewValue)

  useEffect(() => {
    const handler = setTimeout(
      () => setDebouncedValue(immediateNewValue),
      delay,
    )
    // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed
    // within the delay period. Timeout gets cleared and restarted.
    return () => {
      clearTimeout(handler)
    }
  }, [immediateNewValue, delay])

  return [debouncedValue, setImmediateNewValue, immediateNewValue]
}
